import type { FC, ReactNode } from "react";
import { useEffect, useMemo } from "react";
import { I18nextProvider } from "react-i18next";
import { createUIi18nInstance, type SupportedLanguage } from "./config";

interface LocaleProviderProps {
  language: SupportedLanguage;
  children: ReactNode;
}

export const LocaleProvider: FC<LocaleProviderProps> = ({
  language,
  children,
}) => {
  const i18nInstance = useMemo(() => {
    return createUIi18nInstance();
  }, []);

  useEffect(() => {
    i18nInstance.changeLanguage(language);
  }, [language, i18nInstance]);

  return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
};
